module.exports = __webpack_public_path__ + "img/sleeping-smiley.878566d1.png";